/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-07 11:52:11
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface TIManagementListParams {
  endTimeStart?: any
  endTimeEnd?: any
  sponsorUnit?: any
  current?: any
  size?: any
}

export function getTIManagementList(params: TIManagementListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspTrainingManagement/list`,
    method: 'GET',
    params,
  }
}

export interface DetailParams {
  id?: any
  tenantId?: any
}

// 详情
export function getTIManagementDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspTrainingManagement/detail`,
    method: 'GET',
    params,
  }
}

// 保存编辑
export interface SubmitParams {
  id?: any
  certificateName?: any
  certificateNumber?: any
  classHours?: any
  endTime?: any
  lecturer?: any
  remark?: any
  sponsorUnit?: any
  startTime?: any
  trainingCategory?: any
  trainingLocation?: any
}

export function getTIManagementSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspTrainingManagement/submit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspTrainingManagement/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}

export interface TrainingRecordListParams {
  trainingId?: any
  current?: any
  size?: any
  tenantId?:any
}

export function getTrainingRecordList(
  params: TrainingRecordListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspTrainingRecord/list`,
    method: 'GET',
    params,
  }
}

// 详情
export function getTrainingRecordDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspTrainingRecord/detail`,
    method: 'GET',
    params
  }
}

// 保存编辑
export interface TrainingRecordSubmitParams {
  id?: any
  assessmentScore?: any
  trainingObject?: any
  trainingObjectId?: any
  trainingId?: any
  remark?: any
}

export function getTrainingRecordSubmit(
  body: TrainingRecordSubmitParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspTrainingRecord/submit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getTrainingRecordRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspTrainingRecord/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}
